module.exports = "<app-page><div class=\"joinregion-container mobile-page-content\"><div class=\"layout-column\"><div *ngIf=\"user.regions?.length&gt;1\"><region-element [region]=\"allRegions\"></region-element></div><div *ngFor=\"let region of user.regions\"><region-element [region]=\"region\"></region-element></div><div class=\"flex text-center\" *ngIf=\"user.regions?.length&lt;1\"><h3 class=\"title\">have no regions region, contact an owner.</h3></div></div></div></app-page>";


//////////////////
// WEBPACK FOOTER
// ./src/app/chat/join-region/join-region.component.pug
// module id = 1052
// module chunks = 0